// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BackHeaderCommon_wrap__14CbR","icon":"BackHeaderCommon_icon__1Ibx6","title":"BackHeaderCommon_title__2wmom"};